import React from "react";
import { PollComponent } from "./PollComponent";
import { MediaGrid } from "./MediaGrid";
import { PostType, MealType } from "@/types/post";
import { MealContent } from "./MealContent";
import RoutePostContent, { RouteData } from "./RoutePostContent";

interface PostContentProps {
  content: string;
  type: string;
  poll?: any;
  hasVoted: boolean;
  pollResults: { [key: number]: number };
  totalVotes: number;
  onVote: (optionId: number) => Promise<void>;
  medias?: any[];
  postId: string; // Changed from number to string for UUIDs
  meal?: MealType;
  locationName?: string | null;
  routeData?: RouteData;
}

export function PostContent({
  content,
  type,
  poll,
  hasVoted,
  pollResults,
  totalVotes,
  onVote,
  medias,
  postId,
  meal,
  locationName,
  routeData,
}: PostContentProps) {
  // Debug logging disabled for production
  // console.log("PostContent received:", {
  //   type,
  //   meal,
  //   routeData,
  //   isMealType: type === "meal",
  //   hasMeal: !!meal,
  //   mealDetails: meal ? {
  //     nutritionalInfo: meal.nutritionalInfo,
  //     isOrganic: meal.isOrganic,
  //     hasSeedOils: meal.hasSeedOils
  //   } : null
  // });
  
  return (
    <div className="flex flex-col w-full">
      <p className="mt-5 mb-2 whitespace-pre-wrap">{content}</p>

      {type === "poll" && poll && (
        <PollComponent
          poll={poll}
          hasVoted={hasVoted}
          pollResults={pollResults}
          totalVotes={totalVotes}
          onVote={onVote}
        />
      )}

      {medias && medias.length > 0 && (
        <MediaGrid
          medias={medias}
          postId={postId}
        />
      )}

      {type === "meal" && meal && (
        <div className="mt-6 clear-both">
          <MealContent
            meal={meal}
            locationName={locationName}
          />
        </div>
      )}
      
      {type === "meal" && !meal && (
        <div className="hidden">
          {/* Meal post without data - hidden */}
        </div>
      )}

      {type === "route" && routeData && (
        <RoutePostContent routeData={routeData} />
      )}
      
      {type === "route" && !routeData && (
        <div className="hidden">
          {/* Route post without data - hidden */}
        </div>
      )}
    </div>
  );
}